<template>
  <section>
    <div class="tab-wrap">
      <button type="button" class="tab-item" :class="{ active: reqData.partnerType === 'senior' }" @click="changeListType" value="senior">시니어</button>
      <button type="button" class="tab-item" :class="{ active: reqData.partnerType === 'master' }" @click="changeListType" value="master">마스터</button>
      <button type="button" class="tab-item" :class="{ active: reqData.partnerType === 'agency' }" @click="changeListType" value="agency">에이전시</button>
    </div>
    <div class="searchBar">
      <div class="box-ui-check searchbar-content mr-5">
        <div class="title">
          <span>날짜</span> :
        </div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" :configs="dateConfigs" />
      </div>
      <div class="box-ui-check searchbar-content mr-5">
        <div class="title"><span>검색기준</span> :</div>
        <select v-model="searchOptions.type" @change="searchTypeChange">
          <option value="">전체</option>
          <option value="memId">아이디</option>
          <option value="memName">회사명</option>
        </select>
      </div>
      <input type="text" placeholder="검색어 입력" v-model="searchOptions.text" />
      <button class="btn-search" type="button" @click="pageSeach">
        검색
      </button>
    </div>
    <div class="main-contents-wrapper">
      <article class="total-info-container fx-col-sbw">
        <div class="total-info-wrap">
          <div class="total-info-item">
            <img :src="require('@/assets/img/searchicon.png')" />
            검색
            <span>검색결과</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_list_count`) }}</span> : <span class="value">{{ pageInfo.tatal_list_count }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.page`) }}</span> : <span class="value">{{ pageInfo.page }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_page_count`) }}</span> : <span class="value">{{ pageInfo.tatal_page_count }}</span>
          </div>
        </div>
      </article>
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody>
            <template v-if="tableData">
              <tr v-for="(item, idx) in tableData" :key="item.ip">
                <td>{{ idx + 1 }}</td>
                <td width="210px">
                  <span style="font-weight:900;" v-if="!item.recommenderId">OPERATOR</span>
                  <button v-else type="button" class="btn-link fc-nick"  @click="goToPageName('company',item.recommenderId)">{{ item.recommenderId }}</button>
                </td>
                <td width="210px">
                  <button type="button" class="btn-link fc-green" @click="goToPageName('company', item.memid)">{{ item.memid }}</button>
                </td>
                <td>{{ item.memName }}</td>
                <!-- <td>{{ item.domain }}</td> -->
                <td>{{ item.cashInAmt }}</td>
                <td>{{ item.cashOutAmt }}</td>
                <td>{{ item.betAmt }}</td>
                <td>{{ item.betWinAmt }}</td>
                <td>{{ item.cashAmt }}</td>
                <td>{{ item.pointAmt }}</td>
                <td>0</td>
                <td>{{ item.belongCnt }}</td>
                <!-- <td>{{ item.regDt }}</td> -->
                <td>{{ item.ptFeeAmt }}</td>
                <td>{{ item.ptFeeRate }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="14">데이터가 없습니다.</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="tableData && tableData.length > 0" @goPage="goPage" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="Number(pageInfo.tatal_list_count)" />
  </section>
</template>

<script>
import lodash from "lodash";
import TableHead from "@/components/main/table/Head.vue";
import Pagination from "@/components/common/Pagination";
import DateSelector from "@/components/common/DateSelector";
import { getSiteData } from "@/libs/auth-helper";
import { getCode } from "@/api/utils";
import { companyStatistics } from "@/api/company";
import { replceDateT, numberWithCommas, getDateStr } from "@/libs/utils.js";
export default {
  name: "AdminList",
  components: {
    TableHead,
    Pagination,
    DateSelector
  },
  data() {
    return {
      tableName: this.$route.name,
      headInfo: {
        fstColumn: false,
        // dataList: ["index", "id", "companyName", "domain", "inAmt", "outAmt", "betAmt", "betWinAmt", "cashAmt", "pointAmt", "signUpCnt", "regDt", "credit", "feeRate"]
        dataList: ["index", "recommenderId", "id", "companyName", "inAmt", "outAmt", "betAmt", "betWinAmt", "cashAmt", "pointAmt","signUpCnt", "userCnt",  "credit", "feeRate"]
      },
      reqData: {
        memId: "",
        memName: "",
        domain: "",
        startDate: "",
        endDate: "",
        partnerType: "senior",
        page: 1,
        tatal_list_count: 30
      },
      startDefault: "",
      endDefault: "",
      dateConfigs: {
        enableTime: false,
        dateFormat: "Y-m-d"
      },
      siteInfo: {},
      totalInfo: {},
      tableData: null,
      searchOptions: {
        type: "",
        text: ""
      }
    };
  },
  methods: {
    async goPage(page) {
      await this.setTableData(page);
    },
    async changeListType(evt) {
      const target = evt.target;
      const chooseType = target.value;
      this.reqData.partnerType = chooseType;
      this.setTableData(1);
    },
    getSiteInfo() {
      const siteInfoCookie = getSiteData();
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie);
        return siteInfo;
      }
    },
    searchTypeChange() {
      this.reqData[this.searchOptions.type] = this.searchOptions.text;
    },
    setStartDate(date) {
      // console.log(date);
      let _date = "";
      if (!date) {
        _date = new Date();
        // _date.setHours(0, 0, 0);
      } else {
        _date = date[0];
      }
      this.startDefault = _date;
      this.reqData.startDate = getDateStr(_date, "yyyy-MM-dd");
    },
    setEndDate(date) {
      // console.log(date[0]);
      let _date = "";
      if (!date) {
        _date = new Date();
        // _date.setHours(23, 59, 59);
      } else {
        _date = date[0];
      }
      this.endDefault = _date;
      this.reqData.endDate = getDateStr(_date, "yyyy-MM-dd");
    },
    searchDateSetting() {
      this.setStartDate();
      this.setEndDate();
    },
    searchReset() {
      this.searchOptions.type = "";
      this.searchOptions.text = "";
    },
    pageSeach() {
      const searchOptions = this.searchOptions;


      if (searchOptions.text) {
        if (!searchOptions.type) {
          alert('검색기준을 선택해주세요')
          return false
        }
        this.reqData[searchOptions.type] = searchOptions.text;
      } else {
        if (!searchOptions.type) {
          this.reqData.memId = ''
          this.reqData.memName = ''
        }
      }

      this.setTableData(1);
    },

    async getStaticsList(page) {
      const req = lodash.cloneDeep(this.reqData);
      if (!page) {
        req.page = 1
      } else {
        req.page = page
      }
      const res = await companyStatistics(req);
      return res.data;
    },
    async setTableData(page) {
      this.tableData = null
      this.emitter.emit('Loading', true)
      const data = await this.getStaticsList(page);

      const list = data.list;
      if (!list) return;
      if (list.length !== 0) {
        for (const item of list) {
          for (const key in item) {
            if (key.indexOf("Amt") > -1) {
              item[key] = Number(item[key]).toFixed(0);
              item[key] = numberWithCommas(Number(item[key]));
            }
          }
        }
        // console.log(list)
        this.tableData = list;
        this.pageInfo = data.pageInfo;
        this.pageInfo.tatal_list_count = numberWithCommas(this.pageInfo.tatal_list_count);
        this.pageInfo.tatal_page_count = numberWithCommas(Number(this.pageInfo.tatal_page_count) + 1);
        this.emitter.emit('Loading', false)
      } else {
        this.tableData = []
      }
    }
  },
  async created() {
    this.siteInfo = this.getSiteInfo();
    this.searchDateSetting();
    await this.setTableData(1);
  }
};
</script>

<style>
.sub-title {
  font-size: 1em;
  font-weight: 700;
  color: var(--main);
  height: 32px;
  position: relative;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--main);
}
.sub-title > h3 {
  display: flex;
  height: 100%;
  align-items: center;
  width: 180px;
  font-size: 1.4em;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
}
.sub-title > h3::before {
  content: "●";
  color: #18698b;
  margin-right: 7px;
}
textarea {
  width: 100%;
  min-height: 160px;
  border: 1px solid #18698b;
  resize: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 3px;
}
.toggle-wrap {
  width: auto;
  justify-content: center;
}
.pt50 {
  padding-top: 50px;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
}
.item-wrap > div.item-title {
  min-width: 100px;
}
.item-content > select {
  width: 183px;
}
</style>
